'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dIn$002dMaintenance from "./app.api.-General-Practice-App-Update$-In-Maintenance.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$() {
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$ as $c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$ };
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$ as $h_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$ };
$h_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$.prototype.toString__T = (function() {
  return "InMaintenance";
});
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$.prototype.fromProduct__s_Product__Lapp_api_GeneralPracticeAppUpdate$InMaintenance = (function(x$0) {
  var data$2 = x$0.productElement__I__O(0);
  return new $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dIn$002dMaintenance.$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance(data$2);
});
$c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_GeneralPracticeAppUpdate$InMaintenance(p);
});
var $d_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$, "app.api.GeneralPracticeAppUpdate$InMaintenance$", ({
  Lapp_api_GeneralPracticeAppUpdate$InMaintenance$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$ as $d_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$ };
var $n_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$;
function $m_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$() {
  if ((!$n_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$)) {
    $n_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$ = new $c_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$();
  }
  return $n_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$;
}
export { $m_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$ as $m_Lapp_api_GeneralPracticeAppUpdate$InMaintenance$ };
//# sourceMappingURL=app.api.-General-Practice-App-Update$-In-Maintenance$.js.map
